// extracted by mini-css-extract-plugin
export default {"dashboardCard_root":"dashboardHero_dashboardCard_root__GvW7v"};